__turbopack_context__.v({
  "list": "b2tyFa_list",
});
